// extracted by mini-css-extract-plugin
export default {"container":"Layout_container__dVyML","main":"Layout_main__T84kS"};